// Available mutation types
// Grouped by the store modules where they are used

// Accounts
export const ADD_ACCOUNT = 'ADD_ACCOUNT'
export const ADD_ACCOUNTS_LIST = 'ADD_ACCOUNTS_LIST'
export const ADD_ACCOUNTS_REPARTITION = 'ADD_ACCOUNTS_REPARTITION'
export const DELETE_ACCOUNT = 'DELETE_ACCOUNT'
export const DELETE_ACCOUNTS_REPARTITION = 'DELETE_ACCOUNTS_REPARTITION'
export const UPDATE_ACCOUNT_PORTFOLIO = 'UPDATE_ACCOUNT_PORTFOLIO'
export const UPDATE_ACCOUNTS_LIST = 'UPDATE_ACCOUNTS_LIST'

// Banks
export const ADD_BANK_CONTRACTS = 'ADD_BANK_CONTRACTS'
export const ADD_BANKS_LIST = 'ADD_BANKS_LIST'

// Advisors List
export const ADD_ADVISORS_LIST = 'ADD_ADVISORS_LIST'

// Club
export const ADD_CLUB_SUBSCRIPTIONS = 'ADD_CLUB_SUBSCRIPTIONS'
export const UPDATE_CLUB_SUBSCRIPTIONS = 'UPDATE_CLUB_SUBSCRIPTIONS'
export const UPDATE_CLUB_SUBSCRIPTION = 'UPDATE_CLUB_SUBSCRIPTION'
export const ADD_CLUB_PORTFOLIOS_MISSING_INFO = 'ADD_CLUB_PORTFOLIOS_MISSING_INFO'
export const ADD_CLUB_PORTFOLIOS_COMPLETE_INFO = 'ADD_CLUB_PORTFOLIOS_COMPLETE_INFO'
export const UPDATE_CLUB_SUBSCRIPTION_STATE = 'UPDATE_CLUB_SUBSCRIPTION_STATE'
export const ADD_CLUB_PRICING = 'ADD_CLUB_PRICING'
export const CLOSE_WELCOME_CLUB = 'CLOSE_WELCOME_CLUB'
export const UPDATE_SIGN_URL = 'UPDATE_SIGN_URL'

// Contracts
// ⚠ The store module is called Contracts but it does not mirror
// the backend resource called Contracts ⚠
export const ADD_ACCOUNT_PORTFOLIOS = 'ADD_ACCOUNT_PORTFOLIOS'
export const ADD_AGGREGATE_DATA = 'ADD_AGGREGATE_DATA'
export const ADD_CONTRACT_COMPOSITON = 'ADD_CONTRACT_COMPOSITON'
export const ADD_CONTRACT_GRAPH_DATA = 'ADD_CONTRACT_GRAPH_DATA'
export const ADD_CONTRACT_REAL_ESTATE = 'ADD_CONTRACT_REAL_ESTATE'
export const ADD_PORTFOLIO = 'ADD_PORTFOLIO'
export const ADD_PORTFOLIO_ANALYSE = 'ADD_PORTFOLIO_ANALYSE'
export const UPDATE_ANALYSE_DATE = 'UPDATE_ANALYSE_DATE'
export const ADD_PORTFOLIO_ARBITRATION = 'ADD_PORTFOLIO_ARBITRATION'
export const ADD_PORTFOLIO_BANK_FEES = 'ADD_PORTFOLIO_BANK_FEES'
export const ADD_PORTFOLIO_COMPLETE_HISTORY = 'ADD_PORTFOLIO_COMPLETE_HISTORY'
export const ADD_PORTFOLIO_CURRENT_MONTH_EXPENSES = 'ADD_PORTFOLIO_CURRENT_MONTH_EXPENSES'
export const ADD_PORTFOLIO_HISTORY = 'ADD_PORTFOLIO_HISTORY'
export const ADD_PORTFOLIO_OPTIMIZED = 'ADD_PORTFOLIO_OPTIMIZED'
export const ADD_PORTFOLIO_REPARTITION = 'ADD_PORTFOLIO_REPARTITION'
export const ADD_PORTFOLIO_TRANSACTIONS = 'ADD_PORTFOLIO_TRANSACTIONS'
export const ADD_PORTFOLIO_TRANSACTIONS_HISTORY = 'ADD_PORTFOLIO_TRANSACTIONS_HISTORY'
export const ADD_PORTFOLIOS_LIST = 'ADD_PORTFOLIOS_LIST'
export const ADD_PORTFOLIOS_TARGETS = 'ADD_PORTFOLIOS_TARGETS'
export const ADD_PORTFOLIOS_VALUATIONS_TIMESERIES = 'ADD_PORTFOLIOS_VALUATIONS_TIMESERIES'
export const ADD_SURVEY_QUESTIONS = 'ADD_SURVEY_QUESTIONS'
export const ADD_SECTORS_HISTORY = 'ADD_SECTORS_HISTORY'
export const ADD_TRANSACTIONS_CATEGORIES_LIST = 'ADD_TRANSACTIONS_CATEGORIES_LIST'
export const DELETE_CONTRACT_ARBITRATION = 'DELETE_CONTRACT_ARBITRATION'
export const DELETE_CONTRACT_REAL_ESTATE = 'DELETE_CONTRACT_REAL_ESTATE'
export const TOGGLE_ANALYSING = 'TOGGLE_ANALYSING'
export const UPDATE_CONTRACTS_PORTFOLIO = 'UPDATE_CONTRACTS_PORTFOLIO'
export const UPDATE_PORTFOLIO_TRANSACTION = 'UPDATE_PORTFOLIO_TRANSACTION'
export const TOGGLE_NEEDS_REFRESH = 'TOGGLE_NEEDS_REFRESH'
export const STOP_ANALYSING = 'STOP_ANALYSING'

// Interactions
export const ADD_INTERACTIONS_LIST = 'ADD_INTERACTIONS_LIST'
export const DELETE_INTERACTION = 'DELETE_INTERACTION'
export const UPDATE_INTERACTION = 'UPDATE_INTERACTION'

// Loans
export const ADD_LOANS_COMPLETE_HISTORY = 'ADD_LOANS_COMPLETE_HISTORY'
export const ADD_LOANS_COMPOSITION = 'ADD_LOANS_COMPOSITION'
export const ADD_LOANS_HISTORY = 'ADD_LOANS_HISTORY'
export const ADD_LOANS_LIST = 'ADD_LOANS_LIST'
export const ADD_LOANS_REPARTITION = 'ADD_LOANS_REPARTITION'

// Missions
export const ADD_MISSION = 'ADD_MISSION'
export const ADD_MISSION_EVENT = 'ADD_MISSION_EVENT'
export const ADD_MISSION_PRODUCTS = 'ADD_MISSION_PRODUCTS'
export const ADD_ONGOING_MISSIONS = 'ADD_ONGOING_MISSIONS'
export const UPDATE_MISSION_WIZARD = 'UPDATE_MISSION_WIZARD'

// Real estates
export const ADD_REAL_ESTATE = 'ADD_REAL_ESTATE'
export const ADD_REAL_ESTATE_CUMULATIVE_HISTORY = 'ADD_REAL_ESTATE_CUMULATIVE_HISTORY'
export const ADD_REAL_ESTATE_ESTIMATE = 'ADD_REAL_ESTATE_ESTIMATE'
export const DELETE_REAL_ESTATE = 'DELETE_REAL_ESTATE'

// General
export const RESET_MODULE = 'RESET_MODULE'
export const START_APP_LOADING = 'START_APP_LOADING'
export const STOP_APP_LOADING = 'STOP_APP_LOADING'

// Portfolio Builder
export const ADD_PORTFOLIOS_BUILDER_LIST = 'ADD_PORTFOLIOS_BUILDER_LIST'
export const ADD_PRODUCTS_PORTFOLIO_BUILDER_LIST = 'ADD_PRODUCTS_PORTFOLIO_BUILDER_LIST'
export const ADD_PRODUCT_PORTFOLIO_BUILDER_SELECT = 'ADD_PRODUCT_PORTFOLIO_BUILDER_SELECT'
export const UPDATE_PRODUCTS_PORTFOLIO_BUILDER_META = 'UPDATE_PRODUCTS_PORTFOLIO_BUILDER_META'

// Model Portfolio
export const ADD_MODEL_PORTFOLIO_LIST = 'ADD_MODEL_PORTFOLIO_LIST'
export const ADD_MODEL_PORTFOLIO_META = 'ADD_MODEL_PORTFOLIO_META'
export const ADD_MODEL_PORTFOLIO_IN_LIST = 'ADD_MODEL_PORTFOLIO_IN_LIST'

// Form Questionnaire
export const ADD_FORM_QUESTIONNAIRE = 'ADD_FORM_QUESTIONNAIRE'

// Collective Arbitration
export const ADD_COLLECTIVE_ARBITRATION_LIST = 'ADD_COLLECTIVE_ARBITRATION_LIST'
export const ADD_COLLECTIVE_ARBITRATION_META = 'ADD_COLLECTIVE_ARBITRATION_META'
export const ADD_COLLECTIVE_ARBITRATION_AVAILABLE_PORTFOLIOS_LIST = 'ADD_COLLECTIVE_ARBITRATION_AVAILABLE_PORTFOLIOS_LIST'
export const ADD_COLLECTIVE_ARBITRATION_AVAILABLE_PORTFOLIOS_META = 'ADD_COLLECTIVE_ARBITRATION_AVAILABLE_PORTFOLIOS_META'
export const ADD_COLLECTIVE_ARBITRATION_AVAILABLE_LINES = 'ADD_COLLECTIVE_ARBITRATION_AVAILABLE_LINES'

// UX
export const TOGGLE_SIDEBAR_VISIBILITY = 'TOGGLE_SIDEBAR_VISIBILITY'
